export const getMainDomain = (url: string) => {
    const domainPattern = /([^.\s]+\.[^.\s]{2,})$/;
    const match = domainPattern.exec(url);

    return match ? `.${match[1]}` : url;
};
